/* eslint-disable react/prop-types */
import React from 'react';
import { Chip as MuiTag } from '@material-ui/core';
import clsx from 'clsx';
import { Tooltip } from 'components';
import classes from './Tag.module.scss';

const Tag = ({ label, className, tooltip, ...props }) => {
  const tagEl = <MuiTag className={clsx(classes.tag, className)} label={label} {...props} />;
  if (!!tooltip) {
    return (
      <Tooltip
        placement='top-end'
        title={
          <div className={classes.tooltipContent}>
            <span>{tooltip}</span>
          </div>
        }
        arrow>
        {tagEl}
      </Tooltip>
    );
  }
  return tagEl;
};

export default Tag;
